import $ from 'jquery'
import _ from "underscore"
import OverlayTips from "../OverlayTips";
import PageOverlayTipsManager from "../PageOverlayTipsManager"

function LeaveTypesPageOverlayTipsManager(ptoEnabled, sickEnabled)
{
    PageOverlayTipsManager.call(this);
    this.ptoEnabled = ptoEnabled;
    this.sickEnabled = sickEnabled;
}

LeaveTypesPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pageTitleWithSharedSettingsImage"), {
            messageKey: "tips.leave_types.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetY: 0
            }
        });

        this._addTableTips(window.SystemSettings.apPtoBalanceCalculationEnabled, window.SystemSettings.apSickBalanceCalculationEnabled);
    },

    _addTableTips: function(ptoEnabled, sickEnabled)
    {

        this.add(function() {
            if ($("#leaveTypeListTableContainer").find(".leaveTypeListRow").length < 2)
            {
                return $();
            }
            var $element = $("#leaveTypesListTableHeader").find(".leaveTypeChangeOrderCell");
            $element.config = {
                messageKey: "tips.leave_types.order",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                offsetX: -20,
                offsetY: -100,
                wrapInner: true,
                outside: {
                    direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
                    offsetY: 100
                }
            };
            return $element;
        });

        this.add(function() { return $("td.leaveTypeImageCell:gt(0)").eqOrLast(2)}, {
            messageKey: "tips.leave_types.icon",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetX: -20,
            offsetY: -10
        });

        this.add(function() { return $("td.leaveTypeStatusCell").eqOrLast(6)}, {
            messageKey: "tips.leave_type.change_status",
            direction: OverlayTips.DIRECTION_BOTTOM_RIGHT,
            offsetX: -40,
            offsetY: 10
        });

        var leaveTypeAffectedBalanceTipMessageKey = null;
        if (ptoEnabled && sickEnabled)
        {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto_sick_days";
        }
        else if (ptoEnabled)
        {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.pto";
        }
        else if (sickEnabled)
        {
            leaveTypeAffectedBalanceTipMessageKey = "tips.leave_types.sick";
        }

        if (leaveTypeAffectedBalanceTipMessageKey != null)
        {
            this.add(function() { return $("td.leaveTypeAffectedBalanceCell").eqOrLast(1)}, {
                messageKey: leaveTypeAffectedBalanceTipMessageKey,
                direction: OverlayTips.DIRECTION_TOP_RIGHT,
                offsetX: -40
            });
        }
    }
});

export default LeaveTypesPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/actiplans/js/tips/managers/LeaveTypesPageOverlayTipsManager.js